import { tradeAllocationApi } from 'apiConnector/trade-allocation';
import { ofType } from 'redux-observable';
import type { SchedulerLike } from 'rxjs';
import { of } from 'rxjs';
import { catchError, filter, mergeMap, takeUntil, timeoutWith } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import {
  tradeAllocationFormReceived,
  tradeAllocationFormRequestFailed,
  tradeAllocationFormRequestTimedOut,
  tradeAllocationFormResetFailed,
  tradeAllocationFormResetReceived,
} from 'state/tradeAllocationForm/tradeAllocationForm.actions';
import type { WorkspaceTabRemoved } from 'state/workspaces/workspace.actions';

export function fetchTradeAllocationFormEpic(
  timeoutInMillis: number = 60000,
  appScheduler?: SchedulerLike,
): EpicWithThunk {
  return (action$, _state$, { oldHttpClient, getSgmeConfiguration }) => {
    const tradeAllocationFormRequested$ = action$.pipe(ofType('TRADE_ALLOCATION_FORM_REQUESTED'));

    return tradeAllocationFormRequested$.pipe(
      mergeMap(({ tabId, tradeId }) => {
        const tabRemoved$ = action$.pipe(
          ofType('WORKSPACE_TAB_REMOVED'),
          filter((action: WorkspaceTabRemoved) => action.id === tabId),
        );
        const tradeAllocationTimeoutMs = getSgmeConfiguration().tradeAllocationTimeoutMs;

        return tradeAllocationApi(oldHttpClient, tradeAllocationTimeoutMs)
          .fetchFormValues(tabId, tradeId)
          .pipe(
            takeUntil(tabRemoved$),
            mergeMap(tradeAllocationFormResult => of(tradeAllocationFormReceived(tabId, tradeAllocationFormResult))),
            catchError(error => {
              return of(tradeAllocationFormRequestFailed(tabId, tradeId, error.message || 'default form failed'));
            }),
            timeoutWith(timeoutInMillis, of(tradeAllocationFormRequestTimedOut(tabId, tradeId)), appScheduler),
          );
      }),
    );
  };
}
export function resetTradeAllocationFormEpic(
  timeoutInMillis: number = 60000,
  appScheduler?: SchedulerLike,
): EpicWithThunk {
  return (action$, _state$, { oldHttpClient, getSgmeConfiguration }) => {
    const tradeAllocationFormRequested$ = action$.pipe(ofType('TRADE_ALLOCATION_FORM_RESET_REQUESTED'));

    return tradeAllocationFormRequested$.pipe(
      mergeMap(({ tabId, tradeId }) => {
        const tabRemoved$ = action$.pipe(
          ofType('WORKSPACE_TAB_REMOVED'),
          filter((action: WorkspaceTabRemoved) => action.id === tabId),
        );
        const tradeAllocationTimeoutMs = getSgmeConfiguration().tradeAllocationTimeoutMs;

        return tradeAllocationApi(oldHttpClient, tradeAllocationTimeoutMs)
          .fetchFormValues(tabId, tradeId)
          .pipe(
            takeUntil(tabRemoved$),
            mergeMap(tradeAllocationFormResult =>
              of(tradeAllocationFormResetReceived(tabId, tradeAllocationFormResult)),
            ),
            catchError(error => of(tradeAllocationFormResetFailed(tabId, error.message || 'default form failed'))),
            timeoutWith(
              timeoutInMillis,
              of(tradeAllocationFormResetFailed(tabId, `Timeout after ${timeoutInMillis}ms`)),
              appScheduler,
            ),
          );
      }),
    );
  };
}
